import { Tooltip, Typography } from "@bracket/ui";
import { FaceIcon } from "@components";
import styled from "styled-components";

export declare type KycBarProps = {
	scale?: number;
	float?: boolean;
};


export const KycBar = ({
	scale = 1,
	float = false,
}) => {
	const Brace = float ? FloatedBrace : MountedBrace;
	return (
		<Brace $scale={scale}>
			<Tooltip message={"This vault is subject to KYC verification"} position="bottom-start">
				<KycChip>
					<Typography variant="paragraphMD" color={"#bbb"}>
						<KycTypography>
							<FaceIcon color="#bbb" />
							KYC
						</KycTypography>
					</Typography>
				</KycChip>
			</Tooltip>
		</Brace>
	);
};

const MountedBrace = styled.div<{ $scale?: number; $float?: boolean; }>`
	display: flex;
	transform-origin: top center;
	align-items: flex-start;
	justify-content: flex-start;
	transform: scale(${({ $scale }) => $scale || 1});
	transform-origin: top left;
`;

const FloatedBrace = styled(MountedBrace)`
	position: absolute;
	right: 1.2rem;
	top: 1.35em;
`;

const KycChip = styled.div`
	display: flex;
	justify-content: flex-start;
	flex: 1;
	align-items: center;
	border-radius: 10000px;
	background: rgba(224, 224, 224, 0.08);
	transition: background 0.3s ease;
	&:hover {
		background: rgba(224, 224, 224, 0.16);
	}
`;

const KycTypography = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0.25rem;
	gap: 0.25rem;
	scale: 0.85
`;
